var exports = {
  "kL": "SlowmodeIndicator.module__container___ajhHQ2",
  "K2": "SlowmodeIndicator.module__cooldown___ajhHQ2",
  "Pf": "SlowmodeIndicator.module__label___ajhHQ2",
  "Kk": "SlowmodeIndicator.module__icon___ajhHQ2",
};

module.exports = exports;
